<template>
  <div class="d-flex justify-center align-center fill-height mt-4" data-testid="auto-agent-details">
    <div v-if="viewtaskdata.bot_details && viewtaskdata.bot_details._id || viewtaskdata.botid" data-testid="auto-agent-details__content">
      <div @click="getBotRoute(viewtaskdata)" class="d-flex align-center cursor-pointer" data-testid="auto-agent-details__bot-link">
        <img class="mr-2" color="primary" src="/img/navicon/AIAgent.svg" alt="Auto Agent" large data-testid="auto-agent-details__bot-icon"/>
        <span class="hover-router noTransform" data-testid="auto-agent-details__bot-name">{{$constants.BOT_NAME}}: {{ viewtaskdata.bot_details?.name || 'Linked' }}</span>
      </div>
      <div v-if="(viewtaskdata.bot_analysis_detail && viewtaskdata.bot_analysis_detail.name) || viewtaskdata.tmaid" @click="getBotRoute(viewtaskdata)" class="d-flex align-center cursor-pointer" data-testid="auto-agent-details__analysis-link">
        <v-icon class="mr-2" color="caccounting" data-testid="auto-agent-details__analysis-icon">mdi-chart-bar</v-icon>
        <span class="hover-router noTransform" data-testid="auto-agent-details__analysis-name">Analysis: {{ viewtaskdata.bot_analysis_detail?.name }}</span>
      </div>
    </div>
    <div v-else data-testid="auto-agent-details__empty">
      <p class="text-font-size-md grey--text text-center mt-4" data-testid="auto-agent-details__empty-text">No {{$constants.BOT_NAME}} Details Available</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AutoAgentDetails',
  data() {
    return {
      viewtaskdata: this.$store.getters['tasks/getCurrentTask'] || {}
    };
  },
  methods: {
    getBotRoute(item) {
      const id = this.viewtaskdata.project;
      if (item.bot_details?.name === "Lease Schedule") {
        this.$nova.gotoLink({
          path: "/financialclose/automationlease/" + id,
        });
      } else if (item.bot_details?.name === "Borrowing Schedule") {
        this.$nova.gotoLink({
          path: "/financialclose/automationborrowingschedule/" + id,
        });
      } else if (item.bot_details?.name === "Transaction Matching" || item.tmaid) {
        this.$nova.gotoLink({
          path:
            "/financialclose/automationtransactionmatching/" +
            id +
            "/c/" +
            (item.bot_analysis_detail?._id || item.tmaid),
        });
      } else {
        console.log(this.$constants.BOT_NAME +" not found");
      }
    },
  }
}
</script>
